/* eslint-disable no-unused-vars */
export const getPopupSummaryStyle = (_, { palette = {} }) => ({
  popupSummaryContainer: {
    position: 'absolute',
    background: '#FFFFFF',
    boxShadow: '0px 3.2px 7.2px rgba(0, 0, 0, 0.132), 0px 0.6px 1.8px rgba(0, 0, 0, 0.108)',
    borderRadius: 2,
    top: 11,
    left: '50%',
    zIndex: 1,
    paddingBottom: 8,
    paddingTop: 16,
    paddingRight: 16,
    paddingLeft: 16,
  },
  scoreLabel: {
    display: 'flex',
    marginBottom: 2,
    alignItems: 'center',
  },
  gainedScoreLabelIcon: {
    width: 12,
    height: 12,
    border: '1px solid #0078D4',
    background: '#0078D4',
    marginRight: 8,
  },
  scoreLabelText: {
    fontSize: 12,
  },
  scoreValue: {
    fontWeight: 600,
    fontSize: 16,
    color: '#0078D4',
    marginLeft: 20,
    marginBottom: 8,
  },
  dismissedScoreLabelIcon: {
    width: 12,
    height: 12,
    background: '#ABDBFF',
    border: '1px solid #0078D4',
    marginRight: 8,
  },
  scoreHint: {
    fontSize: 12,
    borderTop: 'solid 1px #EDEBE9',
    color: '#666666',
    paddingTop: 6,
    marginBottom: 8,
    minWidth: 186,
  },
});
